import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsMultipleEditPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.locale = this.injector.get('locale');
        this.api = this.injector.get('$http');
        this.depositService = this.injector.get('Deposit');

        this.store = this.stateParams.store;

        this.schema = null;
        this.model = {};

        this.deposits = {
            countries: {},
            languages: {},
            genders: {}
        }

        this._setupEditor();

        this.headline = 'Update mutlitple contacts';
    }

    $onInit() {
        this._loadDeposits();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', [])
            .then((value) => {
                this.deposits.countries = _.merge({'': ''}, value);
            });
        this.depositService.getRemoteDeposit('contacts', 'languages', [])
            .then((value) => {
                this.deposits.languages = value;
            });
        this.depositService.getRemoteDeposit('contacts', 'genders', [])
            .then((value) => {
                this.deposits.genders = value;
            });
    }

    save(fields) {
        return this.locale
            .ready('sweetalerts')
            .then(() => {
                return this.api
                    .put('contacts', {
                        relationship: this.stateParams.relationship,
                        fields,
                        items: this.store.getters.selectedFilters
                    })
                    .then(() => {
                        this.alert.success(
                            this.locale.getString('sweetalerts.records_saved'),
                            this.locale.getString('sweetalerts.records_saved_message')
                        );
                        this.store.dispatch('getData');

                        return this.cancel();
                    }, response => {
                        this.alert.error(
                            this.locale.getString('sweetalerts.saving_unsuccessful'),
                            response.data.message
                        );
                        return this.cancel();
                    });
            });
    }

    cancel() {
        let previous,
            count = 0,
            route = {
                path: _.has(this.state.current.name, 'picklists') ? 'app.picklists.contacts.index' : 'app.contacts.index',
                params: this.stateParams,
                data: {}
            };

        if (!_.has(this.state.current.name, 'picklists')) {
            do {
                previous = this.state.previous(count);
                if (previous && _.endsWith(previous.state.name, '.index')) {
                    route = {
                        path: previous.state.name,
                        params: _.defaults(previous.params, route.params),
                        data: {}
                    };
                    break;
                }
                count++;
            } while (previous && !_.endsWith(previous.state.name, '.index'));
        }

        this.state.go(route.path, route.params, route.data);
    }

    _setupEditor() {
        this.injector.get('Contact')
            .getSchema()
            .then((schema) => {
                this.schema = schema;
                if (!this.store) {
                    this.alert.error('You must first select rows before updating them');
                    this.state.go('app.contacts.index');
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/multi-edit-controller.js